import {builtInSources} from "./built-in-sources";

export interface AdditionalCostVendorConfig {
  key: string
  displayName: string
}

// Auto-derived from standard integrations with additionalCost + costKey. First source wins when two
// share a key (Contact finder bills under the Prospector's).
const derivedVendors: AdditionalCostVendorConfig[] = builtInSources
  .filter((s, i, all) => s.additionalCost && s.costKey && all.findIndex(o => o.costKey === s.costKey) === i)
  .map(s => ({ key: s.costKey!, displayName: s.name }))

// Waterfall sub-keys (one integration maps to multiple cost keys)
const waterfallVendors: AdditionalCostVendorConfig[] = [
  { key: 'waterfall_io_contact_enrich',      displayName: 'Waterfall contact enrichment' },
  { key: 'waterfall_io_company_prospect',    displayName: 'Waterfall company prospection' },
  { key: 'waterfall_io_company_enrich',      displayName: 'Waterfall company enrichment' },
  { key: 'waterfall_io_contact_phoneEnrich', displayName: 'Waterfall phone enrichment' },
  { key: 'waterfall_io_email_verify',        displayName: 'Waterfall email verification' },
  { key: 'waterfall_io_company_find people',        displayName: 'Waterfall find people' },
]

// Non-integration cost vendors (AI models, extra runs)
const extraVendors: AdditionalCostVendorConfig[] = [
  { key: 'gpt',                displayName: 'GPT AI' },
  { key: 'claude',             displayName: 'Claude AI' },
  { key: 'perplexity',         displayName: 'Perplexity' },
  { key: 'datamorf-extra-run', displayName: 'Additional workflow runs' },
  { key: 'prospeo',            displayName: 'Prospeo' },
  { key: 'similar-web-scraper',            displayName: 'Similar Web' },
]

export const ADDITIONAL_COST_VENDORS: AdditionalCostVendorConfig[] = [
  ...derivedVendors,
  ...waterfallVendors,
  ...extraVendors,
]
